import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Language } from '@qtek/shared/models';

export const TranslationCoreActions = createActionGroup({
  source: 'Translation Core',
  events: {
    'Get Translations Success': props<{
      translations: Record<string, string>;
      lang?: Language;
    }>(),
    'Get Translations Error': props<{ error: Error }>(),
    'Get Cached Translations': emptyProps(),
    'Get Cached Translations Success': props<{
      translations: Record<Language, Record<string, string>>;
    }>(),
    'Get Cached Translations Error': props<{ error: Error }>(),
    'Save Translations To Cache': emptyProps(),
    'Save Translations To Cache Success': emptyProps(),
    'Save Translations To Cache Error': props<{ error: Error }>(),
    'Set Language': props<{ language: Language }>(),
    'Set Version': props<{ version: string }>(),
  },
});
